<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">营销</a></el-breadcrumb-item>
          <el-breadcrumb-item>优惠券</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="coupon" label-width="160px">        
        <el-form-item label="优惠券类型">
          <el-col :span="11">
            <el-radio-group v-model="coupon.type">
              <el-radio :label="0">代金券</el-radio>
              <el-radio :label="1">礼品兑换券</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>   
        <el-form-item label="优惠券名称">
          <el-col :span="11">
            <el-input v-model="coupon.name" ></el-input>
          </el-col>
        </el-form-item>  
        <el-form-item label="金额" v-if="coupon.type==0">
          <el-col :span="11">
            <el-input v-model="coupon.value" >
              <el-button slot="append" >元</el-button>
            </el-input>
          </el-col>
        </el-form-item>   
        <el-form-item label="消费满" v-if="coupon.type==0">
          <el-col :span="11">
            <el-input v-model="coupon.consumeValue" >
              <el-button slot="append" >元使用</el-button>
            </el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="售价" v-if="coupon.type==0">
          <el-col :span="11">
            <el-input v-model="coupon.price" >
              <el-button slot="append" >元</el-button>
            </el-input>
          </el-col>
        </el-form-item>
          <el-form-item label="总数量">
          <el-col :span="11">
            <el-input v-model="coupon.totalNumber"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="会员限领数量">
          <el-col :span="11">
            <el-input v-model="coupon.memberLimitNumber"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="有效期">
          <el-col :span="11">
            <el-radio-group v-model="coupon.validityDayType">
              <el-radio :label="0">相对有效期</el-radio>
              <el-radio :label="1">指定日期</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>   
        <el-form-item label="" v-if="coupon.validityDayType==0">          
          <el-col  :span="1">延迟</el-col>
          <el-col :span="6">            
            <el-input v-model="coupon.delayDays"></el-input>
          </el-col>
          <el-col  :span="3">天生效，有效期</el-col>
          <el-col :span="6">
            <el-input v-model="coupon.validityDays"></el-input>
          </el-col>
          <el-col  :span="1">天</el-col>
        </el-form-item>     
        <el-form-item label="有效期" v-if="coupon.validityDayType==1">
          <el-col :span="6">
            <el-date-picker type="date" placeholder="选择日期" v-model="coupon.beginDate" style="width: 100%;"></el-date-picker>
          </el-col>
          <el-col  :span="1">--</el-col>
          <el-col :span="6">
            <el-date-picker placeholder="选择时间" v-model="coupon.endDate" style="width: 100%;"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="使用商家">
          <el-col :span="16">
            <el-transfer v-model="value"
              :props="{
                key: 'id',
                label: 'name'
              }"
              :titles="['待选商家', '已选商家']"
              :data="businesses"></el-transfer>
          </el-col>
        </el-form-item>   
        <el-form-item label="线上显示">
          <el-col :span="12">
            <el-switch
              v-model="coupon.onlineView">
            </el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="Icon图标">
          <el-col :span="12">
            <el-upload
              class="icon-uploader"
              :action="uploadUrl"
              :headers="headers"
              :show-file-list="false"
              :on-success="handleIconSuccess"
              :before-upload="beforeIconUpload">
              <img v-if="coupon.icon" :src="coupon.icon" class="icon">
              <i v-else class="el-icon-plus icon-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">请上传1:1大小的图标(如100px*100px)</div>
            </el-upload>
          </el-col>
        </el-form-item>      
        <el-form-item label="分享描述">
          <el-col :span="11">
            <el-input type="textarea" v-model="coupon.shareDescription"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="描述">
          <editor @showEditor="updateDescription" :content="coupon.description"></editor>
        </el-form-item>
        <el-form-item >
          <el-col :span="11">
            <el-button type="primary" @click="Save">确 定</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { Message } from 'element-ui'
  import editor from '@/components/wang-editor'
  export default {
    props:{
    },
    data (){
      return {
        coupon:{},
        uploadUrl: this.global.serverSrc+'/api/Common/UploadImage',
        headers:{
          Authorization : sessionStorage.getItem('token')
        },
        businesses:[],
        value: []  
      }
    },
    computed:{
      imagesList:function(){
        var result= [];
        if(this.chainStore.images!=undefined){
          var images = this.chainStore.images.split(',');
          images.forEach(element => {            
            let o=  {
              url:element
            }
            //o.url=element
            result.push(o)
          });
        }        
        return result;
      }
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/Coupon/Get',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.coupon = resp.data.coupon
        that.businesses = resp.data.businesses
        if(that.coupon.useBusiness !=null){
          that.value= that.coupon.useBusiness.split(',')
        }
        console.log(that.coupon.validityDayType)
      })
      
    },
    methods:{     
      Save:function(){
        var that = this
        that.coupon.useBusiness = that.value.join(',')
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Coupon/Save',   
          data : that.coupon    
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleIconSuccess(res, file){
        this.chainStore.Icon= res.fullUrl
        //this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeIconUpload(file){
        const isLt2M = file.size / 1024 / 1024 < 2;        
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M;
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        debugger
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handlePictureCardSuccess(res,file,fileList){
        debugger
        if(this.coupon.images==undefined){
          this.coupon.images = res.fullUrl
        }else{
          this.coupon.images += ',' + res.fullUrl;
        }
      },
      updateDescription(data){
        this.coupon.description=data
      },
    },
    components:{    
      editor
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
  .icon-uploader
    .el-upload
      border 1px dashed #d9d9d9
      border-radius 6px
      cursor pointer
      position relative
      overflow hidden
      .el-upload
      &:hover
        border-color #409EFF
      img
        width 100px
        height 100px
  .icon-uploader-icon
    font-size 28px
    color #8c939d
    width 100px
    height 100px
    line-height 100px
    text-align center  
</style>